/**
 * AvItemsController
 * Control the selection of the AV items
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

angular.module('flsControllers').controller('AvItemsController', ['$scope','$window', function($scope, $window){
    $scope.avItems={};
    $scope.requested={ ids:{} };
}]);
